import { InjectionToken } from '@angular/core';

export const LOCK_FEATURE_ENABLED = new InjectionToken<boolean>('LOCK_FEATURE_ENABLED');
